var map = {
	"./additionalInfoIcon.svg": 544,
	"./arrowLeftIcon.svg": 545,
	"./arrowMediumTop.svg": 546,
	"./arrowRightIcon.svg": 547,
	"./arrowRightIconSharp.svg": 548,
	"./arrowRightSmallIcon.svg": 549,
	"./arrowScalableIcon.svg": 550,
	"./arrowSelect2.svg": 551,
	"./arrowSelectIcon.svg": 552,
	"./benefit1.svg": 553,
	"./benefit2.svg": 554,
	"./benefit3.svg": 555,
	"./cardsIcon.svg": 556,
	"./checkCirсleIcon.svg": 557,
	"./circleInfoIcon.svg": 558,
	"./copyIcon copy.svg": 559,
	"./copyIcon.svg": 560,
	"./crossIcon.svg": 561,
	"./crossIcon2.svg": 562,
	"./crossIcon3.svg": 563,
	"./crossIconSmall.svg": 564,
	"./crossSmallIcon.svg": 565,
	"./defaultCategoryIcon.svg": 566,
	"./depNumberIcon.svg": 567,
	"./elfCentralIcon.svg": 568,
	"./equalitySign.svg": 569,
	"./errorIcon.svg": 455,
	"./eyeClosedIcon.svg": 570,
	"./eyeOpenIcon.svg": 571,
	"./favoritesIcon.svg": 572,
	"./favoritesLabelIcon.svg": 573,
	"./filterDivider.svg": 574,
	"./filterIcon.svg": 575,
	"./frequencyIcon.svg": 576,
	"./fsAmountIcon.svg": 577,
	"./fullScreenIcon.svg": 578,
	"./gameIcon.svg": 579,
	"./goldGiftIcon.svg": 580,
	"./hamburgerIcon.svg": 581,
	"./infoIcon.svg": 582,
	"./infoSymbol.svg": 583,
	"./levelBackground.svg": 584,
	"./levelBackgroundNew.svg": 585,
	"./linkIcon.svg": 586,
	"./lockIcon.svg": 587,
	"./lockSharpIcon.svg": 588,
	"./maxBonusAmountIcon.svg": 589,
	"./maxWinFsIcon.svg": 590,
	"./menuIcon.svg": 591,
	"./minDepIcon.svg": 592,
	"./noTournamentIcon.svg": 593,
	"./playIcon.svg": 594,
	"./polygon.svg": 595,
	"./preloaderDotsAnimation.svg": 596,
	"./preloaderSpinnerAnimation.svg": 597,
	"./presentIcon.svg": 598,
	"./promoIcon.svg": 599,
	"./recentIcon.svg": 600,
	"./search2Icon.svg": 601,
	"./search3Icon.svg": 602,
	"./sharpTickIcon copy.svg": 603,
	"./sharpTickIcon.svg": 604,
	"./smallInfoSymbol.svg": 605,
	"./smoothArrowIcon.svg": 606,
	"./successIcon.svg": 607,
	"./supportIcon.svg": 608,
	"./tag1Icon.svg": 609,
	"./tag2Icon.svg": 610,
	"./tag3Icon.svg": 611,
	"./tag4Icon.svg": 612,
	"./tickIcon.svg": 613,
	"./unverified.svg": 614,
	"./verified.svg": 615,
	"./wagerIcon.svg": 616,
	"./wagerTimeIcon.svg": 617,
	"./warningIcon.svg": 618
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 543;